module.exports = __webpack_public_path__ + "fonts/tick-circle.svg";